import React, {
  ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";

import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useInView } from "react-intersection-observer";
import { IconWithToolTip } from "../common";
import { Button, Chip, Drawer, IconButton, Rating, Stack } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SortIcon from "@mui/icons-material/Sort";
// import Attachments from "./attachments";
// import Comments from "./comments";
import { getDateTime } from "../../utils/data";
// import PreviewImageModal from "./previewAttachmentModal";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { appLogger, Http } from "../../utils";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import ThumbDownAltTwoToneIcon from "@mui/icons-material/ThumbDownAltTwoTone";
// import Mailing from "./mailing/mailingDrawer";
// import MailingAnalytics from "./mailing/mailingAnalyticsDrawer";
import { enableInsights, enableAnalytics } from "../../utils/config";
import { FEEDBACK_TYPE_FEEDBACK, IFeedbackType, UserData } from "../../model";
import ReviewReportAccordian from "./ReviewReportAccordian";
// import ReportAccordian from "./ReportAccordian";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const ReviewsReports = (props: any) => {
  const { reportsTicketsData, isFetching, contextProVersion, topic } = props;
  const renderProVersion = (prodid: string, ver: string) => {
    return (
      contextProVersion &&
      contextProVersion.length > 0 &&
      contextProVersion.map((context: any) => {
        if (context.value == prodid && context.version == ver) {
          return context.title;
        }
      })
    );
  };
  return (
    <div className="user-reports">
      {/* {enableInsights && enabledFeatures?.enableInsights ? (
        <Grid xs={12} lg={12} className="insight-card">
          <Box className="insight-item insight-fb-item">
            <h3 className="title insight-card-title">Insights</h3>
            <Stack
              direction="row"
              sx={{
                flexWrap: "wrap",
              }}
              className="insight-card-chip"
            >
              {insightsData &&
                insightsData.data &&
                insightsData.data.NEUTRAL &&
                Object.keys(insightsData.data.NEUTRAL).length == 0 &&
                insightsData.data &&
                insightsData.data.NEGATIVE &&
                Object.keys(insightsData.data.NEGATIVE).length == 0 &&
                insightsData.data &&
                insightsData.data.POSITIVE &&
                Object.keys(insightsData.data.POSITIVE).length == 0 && (
                  <Typography className="no-data">No data</Typography>
                )}
              {insightsData?.data?.POSITIVE &&
                Object.keys(insightsData.data.POSITIVE)
                  .slice(0, 5)
                  .map((keyName, i) => (
                    <Chip
                      key={i}
                      variant="outlined"
                      className={renderClassName("POSITIVE", keyName, i)}
                      onClick={() =>
                        chipFilter(
                          i,
                          "POSITIVE",
                          renderLabel(
                            keyName,
                            insightsData.data.POSITIVE[keyName]
                          ),
                          keyName,
                          FEEDBACK_TYPE_FEEDBACK
                        )
                      }
                      label={
                        <>
                          {renderLabel(
                            keyName,
                            insightsData.data.POSITIVE[keyName]
                          )}
                          <ThumbUpAltTwoToneIcon
                            style={{
                              marginLeft: 4,
                              color: "#038229",
                            }}
                          />
                        </>
                      }
                    />
                  ))}
              {insightsData?.data?.NEUTRAL &&
                Object.keys(insightsData.data.NEUTRAL)
                  .slice(0, 5)
                  .map((keyName, i) => (
                    <Chip
                      key={i}
                      variant="outlined"
                      onClick={() =>
                        chipFilter(
                          i,
                          "NEUTRAL",
                          renderLabel(
                            keyName,
                            insightsData.data.NEUTRAL[keyName]
                          ),
                          keyName,
                          FEEDBACK_TYPE_FEEDBACK
                        )
                      }
                      className={
                        "neutral-thumb-icon" +
                        " " +
                        renderClassName("NEUTRAL", keyName, i)
                      }
                      label={
                        <>
                          {renderLabel(
                            keyName,
                            insightsData.data.NEUTRAL[keyName]
                          )}
                          <ThumbDownAltTwoToneIcon
                            style={{
                              marginLeft: 4,
                              color: "#5e6fed",
                            }}
                          />
                        </>
                      }
                    />
                  ))}
              {insightsData?.data?.NEGATIVE &&
                Object.keys(insightsData.data.NEGATIVE)
                  .slice(0, 5)
                  .map((keyName, i) => (
                    <Chip
                      key={i}
                      variant="outlined"
                      className={renderClassName("NEGATIVE", keyName, i)}
                      onClick={() =>
                        chipFilter(
                          i,
                          "NEGATIVE",
                          renderLabel(
                            keyName,
                            insightsData.data.NEGATIVE[keyName]
                          ),
                          keyName,
                          FEEDBACK_TYPE_FEEDBACK
                        )
                      }
                      label={
                        <>
                          {renderLabel(
                            keyName,
                            insightsData.data.NEGATIVE[keyName]
                          )}
                          <ThumbDownAltTwoToneIcon
                            style={{
                              marginLeft: 4,
                              color: "#f00",
                            }}
                          />
                        </>
                      }
                    />
                  ))}
            </Stack>
          </Box>
        </Grid>
      ) : (
        <></>
      )} */}
      <Grid
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mt: 2, mb: 1.5 }}
      >
        {/* <h2 className="title">ddd</h2> */}

        <Grid item sx={{ flexGrow: 1 }}>
          <Box
            className="sort-wrap"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {/* {data && data.length > 0 && (
              <Button
                id="export-btn"
                sx={{ mb: 0, mr: 1, whiteSpace: "nowrap" }}
                variant="outlined"
                onClick={() => {
                  //! saveExcel is a promise and should either be wrapped in a try catch block or extend the catch
                  saveExcel();
                }}
              >
                {pageType == "FEEDBACK"
                  ? "export feedback"
                  : pageType === "BUGS" || pageType === "BUG_REPORT"
                  ? "export bugs"
                  : "export feature request"}
              </Button>
            )} */}
            {/* <FormControl className="custom-select" fullWidth>
              <InputLabel>Sort By</InputLabel>
              <Select value={sortBy} onChange={selectData}>
                {sortingOptions.length > 0 &&
                  sortingOptions.map((item) => (
                    <MenuItem value={item} id={"sort" + item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl> */}
            {/* {/* <Button
              className="sort-btn"
              variant="text"
              id="sort-order-btn"
              onClick={sortData}
            >
              {sortOrder ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
              <SortIcon /> 
            </Button> */}
          </Box>
        </Grid>
      </Grid>

      <Box
      // className={
      //   update ? "reports-data-wrap reports-loaded" : "reports-data-wrap"
      // }
      >
        {reportsTicketsData.map((datas: any, index: any) => (
          <ReviewReportAccordian
            reportsTicketsData={datas}
            reportsTicketsDataIndex={index}
            renderProVersion={renderProVersion}
            topic={topic}
          />
        ))}
        {isFetching && <div className="chart-item pagination-loader"></div>}
      </Box>

      {/* {detailRow ? (
          <Mailing
            handleDrawerOpen={handleMailDrawerOpen}
            open={mailOpen}
            setOpen={setMailOpen}
            details={detailRow}
          />
        ) : (
          <div />
        )} */}
    </div>
  );
};

export default ReviewsReports;
